import { generatePagerProps } from '@fukuri-admins/utils/common/generatePagerProps';
import { useServiceReport } from './hooks';
import { ServiceReportPresentation } from './presentations';

export const ServiceReport = () => {
  const {
    state: { filteredServiceApplications, loading, currentPage, totalPage, totalCount },
    actions: { handleOutputCsv, handlePageChange, handleHeaderSort },
  } = useServiceReport();

  const pagerProps = generatePagerProps({
    currentPage,
    totalPage,
    totalCount,
    rows: filteredServiceApplications,
    onPageChange: handlePageChange,
  });

  return (
    <ServiceReportPresentation
      filteredServiceApplications={filteredServiceApplications}
      loading={loading}
      pagerProps={pagerProps}
      handleOutputCsv={handleOutputCsv}
      handleHeaderSort={handleHeaderSort}
    />
  );
};
